import Modal from 'react-bootstrap/Modal';
import Button from '@mui/material/Button';

const CombinedMissingFieldsModal = ({ show, onHide, vantiraFields = [], fzeFields = [] }) => {
    return (
        <Modal show={show} onHide={onHide} centered size="lg">
            <Modal.Header style={{ padding: '7px 16px' }} closeButton>
                <Modal.Title>Missing Required Fields</Modal.Title>
            </Modal.Header>
            <Modal.Body className="missing-required-fields-container">
                {vantiraFields.length > 0 && (
                    <>
                        <h6 className="mb-2 fw-bold">Entity: Vantira</h6>
                        <div className="missing-required-fields grid-container mb-4">
                            <div className="grid-header">
                                <span>Missing Fields</span>
                                <span>Tab</span>
                                <span>Section</span>
                            </div>

                            {vantiraFields.map((missingRequiredField, index) => (
                                <div key={index} className="grid-row">
                                    <span>{missingRequiredField.missing_field}</span>
                                    <span>{missingRequiredField.tab}</span>
                                    <span>{missingRequiredField.section}</span>
                                </div>
                            ))}
                        </div>
                    </>
                )}

                {fzeFields.length > 0 && (
                    <>
                        <h6 className="mb-2 fw-bold">Entity: FZE</h6>
                        <div className="missing-required-fields grid-container">
                            <div className="grid-header">
                                <span>Missing Fields</span>
                                <span>Tab</span>
                                <span>Section</span>
                            </div>

                            {fzeFields.map((missingRequiredField, index) => (
                                <div key={index} className="grid-row">
                                    <span>{missingRequiredField.missing_field}</span>
                                    <span>{missingRequiredField.tab}</span>
                                    <span>{missingRequiredField.section}</span>
                                </div>
                            ))}
                        </div>
                    </>
                )}
            </Modal.Body>
            <Modal.Footer className="gap-2">
                <Button variant="outlined" size="small" onClick={onHide}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CombinedMissingFieldsModal;